/**
 * Copyright (c) 2024-2026 Creative Agentics Limited. All rights reserved.
 * Proprietary and confidential. Unauthorised use, reproduction or distribution
 * of this software, in whole or in part, is strictly prohibited.
 * See LICENSE.txt for full terms.
 */

// The individual report's shape, one copy: the interview report and the officer's
// Regenerate both ask for exactly this (individual onboarding, 21/10/2026).
import { GAP_PLAIN_RULE } from './client-copy.js';

export const INDIVIDUAL_REPORT_SCHEMA = `{
  "reportTitle": "Individual Onboarding Assessment Report",
  "clientKind": "individual",
  "clientName": "the client's full name as on their identity document",
  "contactName": "...",
  "contactEmail": "...",
  "submissionDate": "...",
  "accountPurpose": "...",
  "riskTier": "Low / Medium / High",
  "riskRationale": "...",
  "eddRequired": false,
  "eddTriggers": [],
  "fatfFlags": { "entityJurisdictionFlagged": false, "flaggedJurisdictions": [], "fatfStatus": "Clean / Grey List / Black List", "notes": "..." },
  "clientPerson": {
    "fullName": "...", "dateOfBirth": "YYYY-MM-DD or as given", "nationality": "...", "otherNationalities": [],
    "countryOfResidence": "...", "residentialAddress": "...",
    "employmentStatus": "Employed / Self employed / Business owner / Retired / Not working / Student / Other",
    "occupation": "...", "employer": "...", "employerSector": "...", "annualIncome": "...",
    "taxResidence": [],
    "pepDeclaration": { "isPep": false, "familyOrAssociateIsPep": false, "role": "...", "country": "...", "since": "...", "until": "...", "notes": "..." },
    "actingForThemselves": true, "thirdPartyInvolvement": "...",
    "linkedinUrl": "..."
  },
  "declaredAmounts": { "firstDeposit": "...", "firstDepositAmount": 0, "expectedFirst12Months": "...", "expectedFirst12MonthsAmount": 0, "currency": "...", "frequency": "...", "currencies": [] },
  "companyDetails": { "legalName": "the client's full name", "legalForm": "Natural person" },
  "directors": [],
  "ubos": [],
  "authorisedSignatories": [],
  "sowAssessment": { "narrative": "...", "score": "Satisfactory / Basic, monitor / Insufficient", "origins": "...", "timeframe": "...", "significantEvents": "...", "howHeld": "...", "supportingDocs": "...", "notes": "..." },
  "sofAssessment": { "narrative": "...", "score": "Satisfactory / Requires clarification / Insufficient", "namedAccount": "bank and account the money will come from", "accountInOwnName": true, "fundingRoute": "...", "notes": "..." },
  "activityProfile": { "expectedActivity": "...", "monthlyTransactionValue": "...", "typicalTransactionSize": "...", "currencies": "...", "score": "Satisfactory / Elevated (monitor) / Insufficient (clarify)", "notes": "..." },
  "documentsReceived": ["..."],
  "documentGaps": ["..."],
  "sumsubRequired": [{ "name": "the client's full name", "role": "Client (natural person)", "email": "..." }],
  "riskFactors": [{ "factor": "...", "rating": "Low/Medium/High", "notes": "..." }],
  "redFlags": ["..."],
  "taxCompliance": { "declared": false, "declarationText": "...", "riskIndicatorsPresent": false, "riskIndicators": [], "notes": "..." },
  "travelRule": { "wallets": [], "overallStatus": "not_applicable", "notes": "..." },
  "mlroRecommendation": "Approve / Request Additional Information / Escalate / Decline",
  "mlroNotes": "...",
  "reviewPeriod": "1 year / 2 years / 3 years"
}`;


/**
 * The officer's Regenerate for an individual (both dashboard paths): the same
 * schema and gaps discipline as the interview report, and the conversation
 * with the officer's blocks. The firm's thresholds are applied in code after
 * the parse (applyIndividualDocumentRule), never given to the model.
 */
export function individualRegenPrompt(conversationAndBlocks) {
  return 'Generate the full individual compliance report JSON from this onboarding conversation including ALL messages. The client is a natural person opening an account in their own name: never invent company details, directors or shareholders. Output ONLY valid JSON using EXACTLY this schema:\n\n' + INDIVIDUAL_REPORT_SCHEMA +
    '\n\nCRITICAL: documentsReceived, documentGaps and redFlags must be arrays of STRINGS only; riskFactors must be an array of objects. Record declaredAmounts.expectedFirst12MonthsAmount as a plain number and declaredAmounts.currency as a three letter code.' +
    '\n\nDOCUMENT GAPS DISCIPLINE, documentGaps drives what the CLIENT is asked to provide: never list a source of funds or source of wealth document (the platform adds those from the firm\'s rule); never an identity document, selfie or proof of address; never an internal action (identity verification, screening of any kind, Form A); never an amount, a threshold or a band. ' + GAP_PLAIN_RULE +
    '\n\nConversation:\n\n' + String(conversationAndBlocks || '');
}
